import { path, merge } from 'ramda';

import { load } from './googleAPIHandler.helpers';

const copyFile = async (templateTitle: string) => {
  await load('drive', 'v3');

  const copyFileResponse = await gapi.client.drive.files.copy({
    // @ts-expect-error - @types/gapi.client.drive doesn't include name as a valid property
    name: templateTitle,
    fileId: process.env.BASE_TEMPLATE_ID as string,
  });

  const templateId = path(['result', 'id'], copyFileResponse) as string;

  await gapi.client.drive.permissions.create({
    fileId: templateId,
    resource: {
      role: 'writer',
      type: 'domain',
      domain: 'cardlytics.com',
    },
  });

  return { result: merge(copyFileResponse.result, { templateId }) };
};

export { copyFile };
